define('boxes/events/controller-event',[], function() {
    'use strict';

    var controllerEvent = {};
    controllerEvent.RESET = 'RESET';
    return controllerEvent;
});
